/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ChangeRequest,
  Collection,
  Embed,
  PublishedSiteContentLookup,
  RevisionPageDocument,
  RevisionPageGroup,
  SiteVisitorPayload,
  Space,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags urls
 * @name GetContentByUrl
 * @summary Resolve a URL to a content (space, collection, page)
 * @request GET:/urls/content
 * @secure
 */

// @ts-ignore
export const getContentByUrl: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    /** URL to resolve */
    url: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody:
    | {
        collection: Collection;
      }
    | {
        space: Space;
        changeRequest?: ChangeRequest;
        page?: RevisionPageDocument | RevisionPageGroup;
      };
  ResponseStatusCode: 200;
} = {
  route: "/urls/content",
  method: "get",
  streaming: false,
  tags: ["urls"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags urls
 * @name GetEmbedByUrl
 * @summary Resolve a URL to an embed
 * @request GET:/urls/embed
 * @secure
 */

// @ts-ignore
export const getEmbedByUrl: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    /** URL to resolve */
    url: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Embed;
  ResponseStatusCode: 200;
} = {
  route: "/urls/embed",
  method: "get",
  streaming: false,
  tags: ["urls"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags urls
 * @name GetPublishedContentByUrl
 * @summary Resolve a URL of a published content.
 * @request GET:/urls/published
 * @deprecated
 * @secure
 */

// @ts-ignore
export const getPublishedContentByUrl: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    /** URL to resolve */
    url: URL;
    /** JWT token generated for a authenticated access session */
    visitorAuthToken?: string;
    /**
     * When true redirects the user to the authentication/fallback URL if the access token is invalid
     * @default false
     */
    redirectOnError?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: PublishedSiteContentLookup;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/urls/published",
  method: "get",
  streaming: false,
  tags: ["urls"],
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};

/**
 * No description
 * @tags urls
 * @name ResolvePublishedContentByUrl
 * @summary Resolve a URL of a published content.
 * @request POST:/urls/published
 * @secure
 */

// @ts-ignore
export const resolvePublishedContentByUrl: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** URL to resolve */
    url: URL;
    /**
     * When true redirects the user to the authentication/fallback URL if the access token is invalid
     * @default false
     */
    redirectOnError?: boolean;
    /** An object that describes the payload of site visitor info. It can include a jwt token with signed claims and/or a record of its unsigned claims. */
    visitor?: SiteVisitorPayload;
  };
  RequestHeaders: {};
  ResponseBody: PublishedSiteContentLookup;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/urls/published",
  method: "post",
  streaming: false,
  tags: ["urls"],
  criticalityLevel: "low",
  deprecated: false,
};
